import { createReducer, on } from '@ngrx/store';

import { initialNavigationState } from './navigation.state';
import * as NavigationActions from './navigation.actions';

export const navigationReducer = createReducer(
  initialNavigationState,
  on(NavigationActions.setCurrentProduct, (state, { productUuid, category }) => ({
    ...state,
    currentProductUuid: productUuid,
    currentCategory: category,
    isLoading: false,
  })),
  on(NavigationActions.clearCurrentProduct, (state) => ({
    ...state,
    currentProductUuid: null,
    currentCategory: null,
    isLoading: false,
  })),
  on(NavigationActions.setLoading, (state, { isLoading }) => ({
    ...state,
    isLoading,
  })),
  on(NavigationActions.setCurrentCategory, (state, { category }) => ({
    ...state,
    currentCategory: category,
    isLoading: false,
  })),
  on(NavigationActions.clearCurrentCategory, (state) => ({
    ...state,
    currentCategory: null,
    isLoading: false,
  }))
);
